export default "__VITE_ASSET__BooYcOjH__"